<mat-card class="cardWithShadow" style="margin: 0; height: 100%;overflow: hidden;border-radius: 0;">
    <mat-card-header class="w-100 d-block p-0" style="background-color: #1e293b;border-bottom: 3px solid #5d87ff;">
      <mat-card-title>
        <div class="w-100 d-flex" style="background: #0f172a;">
          <span style="display: flex; align-items: center; margin-left: 15px; color: #1bbaee; font-size: 14px;">
            Fonctions avancées - Ghost Mode
          </span> 
          <button class="m-l-auto" mat-icon-button (click)="onClose();">
            <i-tabler name="x" class="icon-18" style="color: #1bb3e6;"></i-tabler>
          </button>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content style="flex: 1;padding: 0;">
      <mat-list style="padding: 0;">
        <ng-container>
          <mat-list-item style="margin: 10px; margin-left: 10px; border-radius: 6px; width: 98%; cursor: pointer; box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;" (click)="doOpenMdCluGhostModeFnRxDbCashDeskModalAction_CashDesk();">
              <span matListItemIcon><i-tabler name="ghost" class="icon-32 d-flex" style="color: #d52a17; align-items: center; margin-top: 4px;"></i-tabler></span>
              <span matListItemTitle class="f-s-16 f-w-600">{{ "Observer les données RxDB [CashDesk]" | translate }}</span>
              <span matListItemLine class="mat-body-1">{{ "Données caisse" | translate }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
        </ng-container>
        <ng-container>
          <mat-list-item style="margin: 10px; margin-left: 10px; border-radius: 6px; width: 98%; cursor: pointer; box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;">
              <span matListItemIcon><i-tabler name="ghost" class="icon-32 d-flex" style="color: #6063ff; align-items: center; margin-top: 4px;"></i-tabler></span>
              <span matListItemTitle class="f-s-16 f-w-600">{{ "Observer les données RxDB [RemDocs]" | translate }}</span>
              <span matListItemLine class="mat-body-1">{{ "Données saisie décentralisées" | translate }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
        </ng-container>
        <ng-container>
          <mat-list-item style="margin: 10px; margin-left: 10px; border-radius: 6px; width: 98%; cursor: pointer; box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;" (click)="doOpenMdCluGhostModeFnAgentTicketsModalAction_CashDesk();">
              <span matListItemIcon><i-tabler name="ghost" class="icon-32 d-flex" style="color: #e2ff60; align-items: center; margin-top: 4px;"></i-tabler></span>
              <span matListItemTitle class="f-s-16 f-w-600">{{ "Observer les tickets synchronisés avec l'Agent" | translate }}</span>
              <span matListItemLine class="mat-body-1">{{ "Tickets synchronisés vers Agent" | translate }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
        </ng-container>
        <ng-container>
          <mat-list-item style="margin: 10px; margin-left: 10px; border-radius: 6px; width: 98%; cursor: pointer; box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;" (click)="doOpenMdCluGhostModeFnZTicketVaultDocumentsModalAction_CashDesk();">
              <span matListItemIcon><i-tabler name="ghost" class="icon-32 d-flex" style="color: #ff60cd; align-items: center; margin-top: 4px;"></i-tabler></span>
              <span matListItemTitle class="f-s-16 f-w-600">{{ "Observer les tickets du coffre" | translate }}</span>
              <span matListItemLine class="mat-body-1">{{ "Tickets du coffre [Copie]" | translate }}</span>
          </mat-list-item>
          <mat-divider></mat-divider>
        </ng-container>
      </mat-list>
    </mat-card-content>
    <mat-card-actions class="d-block m-0 p-0" style="background-color: #0f172a;border-top: 3px solid #5d87ff;">
      <div class="d-flex w-100" style="border-right: 3px solid #1855d5; margin-right: 15px;height: 100px;">
        <button mat-stroked-button style="color: #707387; font-weight: 700; border: 1px solid; margin-left: 10px; margin-right: 10px; flex: 1; margin-top: auto; margin-bottom: auto; height: 80px;" (click)="onClose(true)">
          {{ "FERMER GHOST MODE" | translate }}
        </button>
      </div>
    </mat-card-actions>
  </mat-card>